var _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBronzeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.4182,
    cy: 15.4069,
    r: 14.439,
    fill: "url(#paint0_linear_1775_3747)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6137 26.7988C9.20968 26.7988 4 21.6852 4 15.3996C4 9.11354 9.20968 4 15.6137 4C22.0177 4 27.2278 9.11354 27.2278 15.3996C27.2278 21.6852 22.0177 26.7988 15.6137 26.7988Z",
    fill: "url(#paint1_linear_1775_3747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4403 19.7815C19.4916 20.5105 18.7559 21.0373 18.0823 20.7539L15.9701 19.8653L13.8496 20.7344C13.1735 21.0116 12.4428 20.4782 12.5006 19.7498L12.685 17.4289L11.1949 15.6377C10.7306 15.0796 11.0129 14.228 11.7187 14.0579L13.9618 13.5171L15.1708 11.5557C15.5558 10.9312 16.4652 10.9353 16.8444 11.5633L18.0357 13.536L20.2739 14.0974C20.9781 14.274 21.2526 15.1282 20.7832 15.682L19.277 17.4593L19.4403 19.7815Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1775_3747",
    x1: 12.3519,
    y1: -2.76256,
    x2: 1.57146,
    y2: 26.5715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F480D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1775_3747",
    x1: 14.492,
    y1: -0.20969,
    x2: 0.918406,
    y2: 17.9424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2E03"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBronzeIcon);
export default __webpack_public_path__ + "static/media/bronze-icon.3a332bc37694b9663eff706cbcfec012.svg";
export { ForwardRef as ReactComponent };